import { useGLTF } from '@react-three/drei';
import { GLTFData } from 'scripts/animations/three/types/gltf';
import { BarMaterial, PrimaryMaterial, SecondaryMaterial } from './common/materials';

import ModelUrl from 'assets/gl/home/experiences/promotions.glb?url';

type Props = JSX.IntrinsicElements['group'] & {
    // nothing here yet!
};

type PromotionsGLTF = GLTFData<'bar_1' | 'bar_2' | 'speaker_2' | 'body'>;

export const MusicPromotions = (props: Props) => {
    const { nodes } = useGLTF(ModelUrl) as PromotionsGLTF;
    const { bar_1, bar_2, speaker_2, body } = nodes;

    return (
        <group
            name="Music_promotions"
            position={[0, 0, -0.1]}
            rotation={[0, Math.PI / 9, 0.17]}
            scale={1}
            {...props}
        >
            <group name="Music_promotions_2">
                <group name="music_float">
                    <mesh
                        name="body"
                        geometry={body.geometry}
                        material={PrimaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0.05, 0, -0.01]}
                        rotation={[0, 0, 0]}
                        scale={0.00372}
                    />
                    <mesh
                        name="speaker_2"
                        geometry={speaker_2.geometry}
                        material={SecondaryMaterial}
                        castShadow
                        receiveShadow
                        position={[0.01, 0.01, 0]}
                        rotation={[0, 0, 0]}
                        scale={1.42}
                    />
                    <mesh
                        name="bar_2"
                        geometry={bar_2.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.13, 0.01, 0]}
                        rotation={[-Math.PI / 2, 0, -Math.PI]}
                        scale={1.42}
                    />
                    <mesh
                        name="bar_1"
                        geometry={bar_1.geometry}
                        material={BarMaterial}
                        castShadow
                        receiveShadow
                        position={[0.09, 0.01, 0]}
                        rotation={[-Math.PI / 2, 0, -Math.PI]}
                        scale={1.42}
                    />
                </group>
            </group>
        </group>
    );
};
